module.exports = __webpack_public_path__ + "static/media/stationary.54af4054.jpg";